export const questionUpdateMixin = {
  methods: {
    async updateQuestionAndRefresh(payload) {
      await this.$store.dispatch("examinations/updateFindingQuestions", payload);
      this.$emit('refresh');
    }
  }
};
